module.exports = __webpack_public_path__ + "../static/media/textura-footer.4535195c.png";